module.exports = __webpack_public_path__ + "img/1.fc3bf0dc.png";